import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {VerticalLayoutComponent} from '@layouts/vertical-layout/vertical-layout.component';
import {RouterOutlet} from '@angular/router';
import {HorizontalLayoutComponent} from '@layouts/horizontal-layout/horizontal-layout.component';
import {LayoutStoreService} from '@core/services/layout-store.service';
import {CommonModule} from '@angular/common';
import { FooterComponent } from '@layouts/components/footer/footer.component';
import { LoadingOverlayComponent } from '@app/components/loading/loading-overlay.component';

@Component({
    selector: 'app-main-layout',
    imports: [
        VerticalLayoutComponent,
        RouterOutlet,
        HorizontalLayoutComponent,
        FooterComponent,
        CommonModule,
        LoadingOverlayComponent,
    ],
    templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent implements OnInit, OnDestroy {

    layout = inject(LayoutStoreService)

    ngOnInit() {
        this.layout.setSidenavColor('light')
    }

    ngOnDestroy() {
        this.layout.reset()
    }
}
